import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import {
    ID_FILTER_AMOUNTMODIFIED,
    ID_FILTER_CREATIONDATEFROM,
    ID_FILTER_CREATIONDATETO,
    ID_FILTER_MODE,
    ID_FILTER_MODIFICATIONDATEFROM,
    ID_FILTER_MODIFICATIONDATETO,
    ID_FILTER_SEARCH,
    ID_FILTER_TYPE
} from "../../pages/payments/constants/PaymentsFilters";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import dayjs from "dayjs";

export const usePaymentRepository = () => {
    const { GET } = useApi();

    const PATH = "/finance/payment"

    function getPayments(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let type = getFilterValue(ID_FILTER_TYPE, filterDefs);
        let mode = getFilterValue(ID_FILTER_MODE, filterDefs);
        let amountModified = getFilterValue(ID_FILTER_AMOUNTMODIFIED, filterDefs);
        let creationDateFrom: Date = getFilterValue(ID_FILTER_CREATIONDATEFROM, filterDefs);
        let creationDateTo: Date = getFilterValue(ID_FILTER_CREATIONDATETO, filterDefs);
        let modifiedDateFrom: Date = getFilterValue(ID_FILTER_MODIFICATIONDATEFROM, filterDefs);
        let modifiedDateTo: Date = getFilterValue(ID_FILTER_MODIFICATIONDATETO, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            source: type,
            mode: mode,
            amountModified: amountModified,
            fromCreated: creationDateFrom ? dayjs(creationDateFrom).toISOString() : null,
            toCreated: creationDateTo ? dayjs(creationDateTo).toISOString() : null,
            fromModified: modifiedDateFrom ? dayjs(modifiedDateFrom).toISOString() : null,
            toModified: modifiedDateTo ? dayjs(modifiedDateTo).toISOString() : null,
        }

        return GET(`${PATH}/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getSummary(): Promise<HTTPGenericResponse> {
        return GET(`${PATH}/summary`);
    }
    


    return { getPayments, getSummary};
}